export class Package {
    id: string;
    description: string;
    turnAroundTime: string;
    price: number;
    productDescriptions: PackageProduct[];
    packageLongDescription: string;
    dlRequired: boolean;
}

export class PackageProduct {
    id: number;
    descriptionFA: string;
}